import { render } from "./Hero3D.vue?vue&type=template&id=4336d1aa&scoped=true"
import script from "./Hero3D.vue?vue&type=script&lang=js"
export * from "./Hero3D.vue?vue&type=script&lang=js"

import "./Hero3D.vue?vue&type=style&index=0&id=4336d1aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4336d1aa"]])

export default __exports__